import { Box, Grid, Typography } from '@aircall/tractor';
import { ModalForm } from '@components/ModalForm';
import { TextField } from '@components/TextField/TextField';
import { validateRequired } from '@dashboard/library';
import { useCustomSIPDeviceCreation } from '@hooks/useCustomSIPDeviceCreation';
import { useTranslation } from 'react-i18next';

interface SIPDeviceCreationFormProps {
  onClose: () => void;
  show: boolean;
}

const INITIAL_VALUES = { domain: '', username: '' };

export function SIPDeviceCreationForm({ onClose, show }: SIPDeviceCreationFormProps) {
  const { t } = useTranslation();
  const { onCustomSIPDeviceSubmit } = useCustomSIPDeviceCreation({
    onCompleted: onClose,
  });

  return (
    <ModalForm
      title={t('user_profile.call_preferences.sip_creation.title')}
      formProps={{ onSubmit: onCustomSIPDeviceSubmit, initialValues: INITIAL_VALUES }}
      onHide={onClose}
      show={show}
      submitButtonText={t('user_profile.call_preferences.sip_creation.form.submit_button')}
    >
      {() => (
        <Box px='m' py='l'>
          <Typography variant='subheading'>
            {t('user_profile.call_preferences.sip_creation.description')}
          </Typography>
          <Grid
            gridTemplateColumns={{
              _: 'repeat(1, 1fr)',
              md: 'repeat(2, 1fr)',
            }}
            mt={22}
            gridGap={32}
          >
            <TextField
              label={t('user_profile.call_preferences.sip_creation.form.domain.label')}
              name='domain'
              data-test='add-sip-device-domain-field'
              validate={validateRequired}
            />
            <TextField
              label={t('user_profile.call_preferences.sip_creation.form.username.label')}
              name='username'
              data-test='add-sip-device-username-field'
              validate={validateRequired}
            />
          </Grid>
        </Box>
      )}
    </ModalForm>
  );
}
